module.exports = __webpack_public_path__ + "media/bootstrap-icons/grid-1x2-fill-7bd29711.svg";